import { getHttpErrorCode, getHttpErrorStatus } from '../../utils/error.utils';

/**
 * Why the consultant AI assistant refused a request (403), with no retry that can succeed:
 * - `noWorkspace`: the consultant has no studio (`consultant_deadlines_no_workspace`);
 * - `aiDisabled`: the studio exists but the back office switched the consultant AI off
 *   (`consultant_ai_disabled`); client requests keep working.
 */
export type ConsultantAssistantBlock = 'noWorkspace' | 'aiDisabled';

/** Same block read from `GET /consultant/access` flags, before any request: null while loading or when on. */
export function consultantAssistantBlockOfAccess(access: {
  isPending: boolean;
  hasConsultantWorkspace: boolean;
  consultantAiEnabled: boolean;
}): ConsultantAssistantBlock | null {
  if (access.isPending) {
    return null;
  }
  if (!access.hasConsultantWorkspace) {
    return 'noWorkspace';
  }
  return access.consultantAiEnabled ? null : 'aiDisabled';
}

export function consultantAssistantBlockOf(error: unknown): ConsultantAssistantBlock | null {
  if (getHttpErrorStatus(error) !== 403) {
    return null;
  }
  const code = getHttpErrorCode(error);
  if (code === 'consultant_deadlines_no_workspace') {
    return 'noWorkspace';
  }
  if (code === 'consultant_ai_disabled') {
    return 'aiDisabled';
  }
  return null;
}
